<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useStore } from 'vuex';

import PostalAddress from '@/components/base/PostalAddress.vue';
import SavedShipment from '@/components/checkout/steps/multiship/SavedShipment.vue';
import { useCart } from '@/composables/useCart';
import { useDelivery } from '@/composables/useDelivery';
import { useCustomer } from '@/stores/customer';

const store = useStore();
const { customerEmail } = useCart(store);
const { customer } = storeToRefs(useCustomer());
const { hasMultipleShipments, isPickup, standardShipments } = useDelivery(store);
</script>

<template>
  <div class="divide-y divide-gray-200 divide-solid" data-test="saved-address-summary">
    <template v-if="hasMultipleShipments">
      <div v-if="!customer">
        <strong class="text-sm leading-4 md:leading-5 md:text-base">
          Email Address for Order Updates
        </strong>
        <div class="mb-5 text-sm leading-4 md:leading-5 md:text-base">
          {{ customerEmail }}
        </div>
      </div>
      <SavedShipment
        v-for="shipment in standardShipments"
        :key="shipment.key"
        class="pt-5 mb-5"
        :addressNumber="shipment.multishipSerial"
        :shipment
      />
    </template>
    <div v-else>
      <template v-if="!customer && !isPickup && customerEmail">
        <strong class="text-sm leading-4 md:leading-5 md:text-base">
          Email Address for Order Updates
        </strong>
        <div class="mb-5 text-sm leading-4 md:leading-5 md:text-base">
          {{ customerEmail }}
        </div>
      </template>
      <template v-if="isPickup">
        <div class="mb-4 text-sm font-normal leading-4 md:leading-5 md:text-base">
          Order to be picked up at Cranford. Delivery address not required.
        </div>
        <strong class="text-sm leading-4 md:leading-5 md:text-base"> Pickup contact: </strong>
        <div class="text-sm font-normal leading-4 md:leading-5 md:text-base">
          {{ standardShipments[0].address.name }}
        </div>
        <div class="text-sm font-normal leading-4 md:leading-5 md:text-base">
          {{ standardShipments[0].address.phone }}
        </div>
      </template>
      <template v-else-if="standardShipments[0]?.needPhysicalAddress">
        <strong class="text-sm leading-4 md:leading-5 md:text-base"> Shipping Address </strong>
        <PostalAddress :address="standardShipments[0].address" />
      </template>
      <template v-if="standardShipments[0]?.needEmailAddress">
        <div class="mt-5 text-sm leading-4 md:leading-5 md:text-base">
          <strong>Gift Certificate Recipient</strong>
          <div v-if="!standardShipments[0].hasPhysical">
            {{ standardShipments[0].address.name }}
          </div>
          <div>{{ standardShipments[0].address.email }}</div>
        </div>
      </template>
    </div>
  </div>
</template>
